export const MENU_PANEL_WIDTH_PX = 40;
export const MIN_PANEL_WIDTH_PX = 340;
export const MAX_PANEL_WIDTH_PX = 640;
export const DEFAULT_PANEL_WIDTH_PX = MIN_PANEL_WIDTH_PX;

export enum SidePanelTabName {
  Missions = 'Missions',
  ProjectData = 'ProjectData',
  Workspaces = 'Workspaces',
  Views = 'Views',
  Styles = 'Styles',
  Measurements = 'Measurements',
  Settings = 'Settings',
  IssueManagement = 'IssueManagement',
}

export enum RightPanelTabName {
  ViewDetails = 'ViewDetails',
  CreateView = 'CreateView',
  ModelDetails = 'ModelDetails',
  RunDetails = 'RunDetails',
  MissionDetails = 'MissionDetails',
  MeasurementDetails = 'MeasurementDetails',
  ObjectProperties = 'ObjectProperties',
  FeatureProperties = 'FeatureProperties',
  Layout = 'Layout',
  Settings = 'Settings',
  ExtractionWorkflow = 'ExtractionWorkflow',
}

/** Wizard tabs whose form state is session-only and must not reopen empty after reload. */
export function restorePersistedRightPanelTab(
  tab: RightPanelTabName | undefined
): RightPanelTabName | undefined {
  if (tab === RightPanelTabName.ExtractionWorkflow) {
    return undefined;
  }
  return tab;
}
